import React from 'react';
import classnames from 'classnames';

export default function DropdownDisplay(props) {
  return (
    <div
      className={classnames('dropdown-display', 'dropdown-choice', 'selected', props.className)}
      onClick={props.clickHandler}
    >
      {props.children}
      <div className="toggle-container">
        <b className="toggle-container-icon" />
      </div>
    </div>
  );
}

DropdownDisplay.propTypes = {
  children: React.PropTypes.element,
  clickHandler: React.PropTypes.func,
  className: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown-display.jsx